import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../lib/theme";

/**
 * Small square icon-only toggle. Sits comfortably next to other nav
 * buttons (.btn-ghost compatible sizing).
 */
export default function ThemeToggle({ size = 34, testId = "theme-toggle" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      title={isDark ? "Switch to light theme" : "Switch to dark theme"}
      data-testid={testId}
      data-theme-state={theme}
      style={{
        width: size,
        height: size,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
        background: "transparent",
        border: "1px solid var(--pf-border)",
        borderRadius: 2,
        color: "var(--pf-text)",
        cursor: "pointer",
        transition: "border-color 0.15s ease, color 0.15s ease, background 0.15s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = "var(--pf-accent)";
        e.currentTarget.style.color = "var(--pf-spark)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = "var(--pf-border)";
        e.currentTarget.style.color = "var(--pf-text)";
      }}
    >
      {isDark ? <Sun size={15} strokeWidth={2} /> : <Moon size={15} strokeWidth={2} />}
    </button>
  );
}
